import { Timestamp } from "firebase/firestore";

export type ProjectStatus = "not_started" | "in_progress" | "delivered" | "sav";

export const PROJECT_STATUS_OPTIONS: { value: ProjectStatus; label: string }[] = [
  { value: "not_started", label: "En attente" },
  { value: "in_progress", label: "En cours" },
  { value: "delivered", label: "Livrés" },
  { value: "sav", label: "SAV" },
];

export interface Broadcast {
  id: string;
  title: string;
  content: string;
  author: {
    id: string;
    display_name: string;
    color_tag: string;
  };
  org_id: string;
  start_date: Timestamp;
  end_date: Timestamp;
  status: "active" | "inactive";
  project_visibility?: ProjectStatus[];
  created_at: Timestamp;
  updated_at: Timestamp;
}
